import React from 'react';
import { Link } from 'react-router-dom';

const NotFound = () => {
  return (
    <section className="hero" style={{ minHeight: '60vh', display: 'flex', alignItems: 'center' }}>
      <div className="container hero-content fade-up" style={{ textAlign: 'center' }}>
        <div style={{ fontSize: '4rem', marginBottom: '16px' }}>🐾</div>
        <h1 className="hero-title" style={{ fontSize: '3rem' }}>
          404 — <span className="text-gradient">Page Not Found</span>
        </h1>
        <p className="hero-subtitle">
          Looks like this page ran off. Let's get you back on track.
        </p>
        <div style={{ display: 'flex', gap: '16px', justifyContent: 'center', flexWrap: 'wrap' }}>
          <Link to="/" className="btn btn-gradient btn-lg">
            Back to Home
          </Link>
          <Link to="/contact" className="btn btn-outline btn-lg">
            Contact Us
          </Link>
        </div>
      </div>
    </section>
  );
};

export default NotFound;
